import CryptoJS from 'crypto-js';
var EncryptionService = /** @class */ (function () {
    function EncryptionService() {
    }
    /**
     * Encrypts a user ID using AES-256 CBC before sending to the backend.
     * The KEY and IV must match exactly what is configured on the backend (appsettings.json).
     */
    EncryptionService.encryptUserId = function (userId) {
        if (!userId) {
            throw new Error('User ID cannot be empty');
        }
        var key = CryptoJS.enc.Base64.parse(this.KEY);
        var iv = CryptoJS.enc.Base64.parse(this.IV);
        var encrypted = CryptoJS.AES.encrypt(userId, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });
        return encrypted.toString(); // Base64 encoded ciphertext
    };
    EncryptionService.KEY = process.env.VUE_APP_ENCRYPTION_KEY;
    EncryptionService.IV = process.env.VUE_APP_ENCRYPTION_IV;
    return EncryptionService;
}());
export { EncryptionService };
